// Primeiro import do bundle, de proposito: garante que o Sentry esteja
// inicializado antes de qualquer outro módulo da aplicação carregar.
import './instrument';

import { AppThemeProvider } from './themes/AppThemeProvider';
import ReactDOM from 'react-dom/client';
import React from 'react';
import App from './App';
import './main.css';
import { SnackbarProvider } from 'notistack';
import LoadingBackdrop from '@/components/Base/LoadingBackdrop';
import { ErrorBoundary } from '@/components/ErrorBoundary';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <SnackbarProvider maxSnack={3}>
        <AppThemeProvider>
          <App />
          <LoadingBackdrop />
        </AppThemeProvider>
      </SnackbarProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
